import { Component, ViewEncapsulation } from '@angular/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { Cart } from '@spartacus/cart/base/root';
import { CheckoutOrderSummaryComponent } from '@spartacus/checkout/base/components';
import { Observable } from 'rxjs';
import { UigCheckoutService } from "../uig-checkout.service";

@Component({
    selector: 'app-uig-checkout-order-summary',
    templateUrl: './uig-checkout-order-summary.component.html',
    styleUrls: ['./uig-checkout-order-summary.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigCheckoutOrderSummaryComponent extends CheckoutOrderSummaryComponent {

  cart$: Observable<Cart>;
  directDelivery$: Observable<boolean>;
  pickup$: Observable<boolean>;

  constructor(protected activeCartService: ActiveCartService,
              private uigCheckoutService: UigCheckoutService) {
    super(activeCartService);
    this.cart$ = this.activeCartService.getActive();
    this.directDelivery$ = this.uigCheckoutService.deliveryAddressMode;
    this.pickup$ = this.uigCheckoutService.pickup;
  }
}
